<template>
  <div class="updateCheckpoint_wrapper">
    <headView :option="title" :subtitleOpt="subtitleOpt"></headView>
    <div class="updateCheckpoint_body">
      <control-point :id="$route.params.id"/>
      <task-list/>
      <check-point-buildings v-if="currentlinkedbuildings" :viewActive="viewLocal" :currentBuild="currentlinkedbuildings"/>
    </div>
    <footer class="button-wrapper">
      <div class="wrap-btn-content" v-if="role">
          <button class="button button-custom ripple btn-action wrap-btn-content--one"  @click="backtoControlpoint">Volver atrás</button>
          <button class="button button-custom ripple btn-action wrap-btn-content--two" @click="actualizarCP()" v-if="$route.params.id">Actualizar punto de control</button>
          <button class="button button-custom ripple btn-action wrap-btn-content--three" @click="preventDialogUpControlPoint()" v-if="$route.params.id">Eliminar punto de control</button>
        </div>
    </footer>
  </div>
</template>

<script>
import controlPoint from "./controlPointIn";
import TaskList from "./listaTareas";
import CheckPointBuildings from "./PuntoControlEdificio";
import headView from "../Componentes/headView";
import { mapGetters } from "vuex";
export default {
  name: "updateCheckPoint",
  components: {
    controlPoint,
    TaskList,
    CheckPointBuildings,
    headView
  },
  data() {
    return {
      title: {
        headText: "Editar Puntos de Control",
        subtitle: ""
      },
      subtitleOpt: false,
      viewLocal: "controlPoint"
    };
  },
  computed: {
    ...mapGetters(["currentCP", "currentlinkedbuildings", "role"])
  },
  created() {
    this.$store.dispatch("GETCHECKPOINT", {
      id_company: this.$store.getters.company_id,
      id_checkpoint: this.$route.params.id
    });
  },
  beforeDestroy() {
    this.$store.commit("resetCP_id");
    this.$store.commit("resetNewControlPoint");
    this.$store.commit("resetImageTemp");
  },
  methods: {
    backtoControlpoint() {
      this.$router.push({ name: "puntocontrol" });
    },
    actualizarCP() {
      this.$store.commit("updateCPImage", this.$store.state.imageTemp.file)
      this.$store
        .dispatch("PUTCHECKPOINT", {
          id_company: this.$store.getters.company_id,
          id_checkpoint: this.$route.params.id,
          obj: this.$store.getters.currentCP
        })
        .then(response => {
          this.$store.commit("resetImageTemp");
          this.backtoControlpoint();
          this.upS();
        });
    },
    preventDialogUpControlPoint() {
      this.$dialog.confirm({
        title: "Punto de control",
        message:
          "Se eliminará el punto de control del sistema.</br> <strong>¿Desea continuar?</strong>",
        confirmText: "Ok",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => this.borrarCP()
      });
    },
    borrarCP() {
      this.$store
        .dispatch("DELETECHECKPOINT", {
          id_company: this.$store.getters.company_id,
          id_checkpoint: this.$route.params.id
        })
        .then(response => {
          this.backtoControlpoint();
          this.borrarS();
        });
    },
    borrarS() {
      this.$toast.open({
        message: "Punto de control eliminado",
        type: "ffcolor-is-delete",
        position: "is-bottom-right",
        queue: false
      });
    },
    upS() {
      this.$toast.open({
        message: "Punto de control actualizado",
        type: "ffcolor-is-success",
        position: "is-bottom-right",
        queue: false
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.updateCheckpoint_wrapper {
  height: 100%;
}
.updateCheckpoint_body {
  margin: auto;
  padding-top: 70px;
  padding-left: 30px;
  padding-right: 30px;
  // height: 100%;
}
.button-wrapper {
  margin: auto;
  padding-top: 70px;
  padding-left: 60px;
  padding-right: 60px;
}
.wrap-btn-content {
  padding: 10px 0;
  display: flex;
  flex-flow: row wrap;
  width: 460px;
  .btn-action {
    border-radius: 3px;
    width: 220px;
    // margin-left: 0;
    // margin-right: 0;
  }
  &--one {
    margin-left: 0;
    margin-right: 10px;
    background-color: #c9c9c9;
  }
  &--two {
    margin-right: 0;
    margin-left: 10px;
    background-color: #1abc9c;
  }
  &--three {
    margin-top: 20px;
    // margin-right: 0;
    // margin-left: 10px;
    background-color: #d0021b;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Main/updateControlPoint.vue